import { DcBaseComponent } from '@deleteagency/dc';
import { modalService } from 'general/js/modal-service';
import onScriptLoaded from 'general/js/loadYotubeScript';

export default class VideoModal extends DcBaseComponent {
    constructor(...args) {
        super(...args);
        this.playerPromise = null;
        this.playerContainerClone = this.refs.player.cloneNode(true);
    }

    static getNamespace() {
        return 'video-modal';
    }

    static getRequiredRefs() {
        return ['player'];
    }

    onInit() {
        this.player.then(() => {});
        this.createModal();
        this.addListeners();
    }

    addListeners() {
        this.addListener(this.element, 'click', () => {
            if (this.modal) {
                this.modal.open();
            }
        });
    }

    get player() {
        if (this.playerPromise === null) {
            this.playerPromise = new Promise((resolve) => {
                onScriptLoaded(() => {
                    this.createPlayer(resolve);
                });
            });
        }

        return this.playerPromise;
    }

    createModal() {
        const options = {
            bemList: ['video'],
            onOpen: async () => await this.onPlayVideo(),
            onClose: this.closeModal,
        };

        this.playerContainerClone.classList.add('in-modal');

        this.modal = modalService.create(this.playerContainerClone, options);
    }

    createPlayer(resolve) {
        const player = new YT.Player(this.playerContainerClone, {
            events: {
                onReady: () => {
                    resolve(player);
                }
            }
        });
    }

    closeModal = async () => {
        await this.onPauseVideo();

        if (this.modal) {
            this.modal.destroy();
        }
    }

    async onPlayVideo() {
        return this.player.then((player) => {
            player.playVideo();
        });
    }

    async onPauseVideo() {
        return this.player.then((player) => {
            player.pauseVideo();
        });
    }

    onDestroy() {
        if (this.modal) {
            this.modal.destroy();
        }
    }
}
